import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class TestimonialService {
  // private apiUrl = 'https://qhapi.qairadrones.com/api/get_all_news_web/'; 

  constructor(private http: HttpClient) { }

  getData(): Observable<any[]> {
    return this.http.get<any[]>("../../../../assets/json/testimoniales.json");
  }
}
